import type {
  DailyStatisticsDto,
  MainPageSeoDto,
} from '@features/home/api/home.dto'
import {
  mapDailyStatisticsDto,
  mapMainPageSeoDto,
} from '@features/home/api/homeMapper'
import type { DailyStatistic, MainPageSeo } from '@features/home/types'
import { useNuxtApi } from '@shared/nuxt/useNuxtApi'

export const homeApi = {
  getSeo() {
    return useNuxtApi<MainPageSeoDto, MainPageSeo>('/api/main-page-seo', {
      transform: mapMainPageSeoDto,
    })
  },

  getDailyStatistics() {
    return useNuxtApi<DailyStatisticsDto, DailyStatistic[]>('/api/daily', {
      transform: mapDailyStatisticsDto,
    })
  },
}
